import usePortalStyles from "../styles/portalStyles";

// import PortalMessaging from "./portalMessaging";
import PortalPrescriptionRefills from "./portalPrescriptionRefills.jsx";

export default function PortalIndex(props) {
  return <PortalPrescriptionRefills />;
}
